import type { components } from '@/api/types'

/**
 * AdminHelpRequest shape (mirrors the backend `AdminHelpRequestResource`,
 * DEC-SUPPORT-001). Carries the full page-context the moderator needs.
 */
export type AdminHelpRequest = NonNullable<components['schemas']['AdminHelpRequest']>

export type HelpRequestStatus = 'open' | 'in_progress' | 'resolved' | 'dismissed'

export const HELP_STATUS_VALUES: HelpRequestStatus[] = [
  'open',
  'in_progress',
  'resolved',
  'dismissed',
]

export type HelpRequestPage =
  | 'own_profile'
  | 'public_profile'
  | 'discovery'
  | 'matches'
  | 'messages'
  | 'other'
